import { platformAdminAssetsManagement } from "./platform-admin-assets-management";
import { platformAdminAssetsOverview } from "./platform-admin-assets-overview";
import { platformAdminAssetsRemediation } from "./platform-admin-assets-remediation";
import { platformAdminAssetsScopes } from "./platform-admin-assets-scopes";
import { platformAdminAssetsShare } from "./platform-admin-assets-share";
import { platformAdminAssetsValues } from "./platform-admin-assets-values";

export const platformAdminAssets = {
  ...platformAdminAssetsScopes,
  ...platformAdminAssetsShare,
  ...platformAdminAssetsRemediation,
  ...platformAdminAssetsValues,
  ...platformAdminAssetsOverview,
  ...platformAdminAssetsManagement,
} as const;
